"use strict";
exports.__esModule = true;
exports.WeakAttrStore = void 0;
/**
 * Holds a weak reference to an AttrStore so that long-lived callbacks floating around in hooks-land
 * don't accidentally retain a reference to this store when its parent node has disappeared and it
 * could otherwise be garbage collected.
 */
var WeakAttrStore = /** @class */ (function () {
    function WeakAttrStore(attrStore) {
        this.attrStore = attrStore;
    }
    WeakAttrStore.prototype.registerRunCallback = function (callback) {
        return this.attrStore && this.attrStore.registerRunCallback(callback);
    };
    WeakAttrStore.prototype.registerDestroyCallback = function (callback) {
        return this.attrStore && this.attrStore.registerDestroyCallback(callback);
    };
    WeakAttrStore.prototype.unregisterDestroyCallback = function (callback) {
        return this.attrStore && this.attrStore.unregisterDestroyCallback(callback);
    };
    WeakAttrStore.prototype.getCurrentCell = function () {
        return this.attrStore && this.attrStore.getCurrentCell();
    };
    WeakAttrStore.prototype.incrementPointer = function () {
        return this.attrStore && this.attrStore.incrementPointer();
    };
    WeakAttrStore.prototype.invalidate = function () {
        return this.attrStore && this.attrStore.invalidate();
    };
    WeakAttrStore.prototype.destroy = function () {
        this.attrStore = null;
    };
    return WeakAttrStore;
}());
exports.WeakAttrStore = WeakAttrStore;
